export default __webpack_public_path__ + "static/10-Yard-Dumpster-02f8e43c4bd019a79da5ae401b421fc4.jpg";